module.exports = __webpack_public_path__ + "static/media/YF81_8.7984010d.jpg";